import principal from "../assets/Images/2.jpg";

export const heroSlides = [
  {
    id: 1,
    content:
      "சிட்னியில் வாழும் தமிழ் பேசும் மக்களிடையே, தமிழ் மொழியும் பண்பாடும் மலர வேண்டும் என்பது  எங்கள் நோக்கம். மொழியின் இனிமையும் மரபின் பெருமையும், எங்கள் இதயங்களில் எப்போதும் ஒலிக்கட்டும்.",
  },
  {
    id: 2,
    content:
      "தமிழ் எங்கள் அடையாளம்; தமிழர் பண்பாடு எங்கள் பெருமை. எங்கள் பிள்ளைகள் தமிழ் மொழியை நேசித்து, மரபுகளை மதித்து, சமூக ஒற்றுமையுடன் வளர வேண்டும் என்பதே எங்கள் கனவு.",
  },
  {
    id: 3,
    content:
      "தலைமுறைகள் மாறினாலும், தமிழ் மொழியின் ஒளி மங்காமல் தொடர வேண்டும். சிட்னியில் தமிழ் கற்கும் ஒவ்வொரு குழந்தையும், நாளைய தமிழ் மரபின் தூதராக மலரட்டும்.",
  },
];

export const blogData = [
  {
    id: 1,
    title: "Western Sydney Tamil Study Centre Inauguration Ceremony",
    description:
      "The inauguration ceremony marked the beginning of a new educational journey for Tamil children and families in Western Sydney. The centre was established to nurture Tamil language learning and cultural identity, creating a welcoming space where students can grow with pride in their heritage. The event saw the participation of parents, community members, and well-wishers who came together to celebrate this meaningful milestone.",
    img: principal,
    date: "Oct 18, 2025",
  },
  {
    id: 2,
    title: "Western Sydney Tamil Study Centre Open Day",
    description:
      "The Open Day provided an opportunity for parents and students to explore the learning environment, meet the teaching team, and understand the vision of the Tamil Study Centre. Interactive sessions, cultural showcases, and orientation activities helped families gain clarity on the curriculum, class structures, and community programs planned for the year ahead.",
    img: principal,
    date: "Oct 25, 2025",
  },
  {
    id: 3,
    title: "Goal of Western Sydney Tamil Study Centre",
    description:
      "Our goal is to ensure that the Tamil language and culture continue to flourish among the Tamil-speaking community living in Western Sydney. We strive to keep the sweetness of our language and the pride of our heritage alive in every heart.",
    img: principal,
    date: "Oct 29, 2025",
  },
];

export const papersByYear = {
  2025: [
    { title: "Mathematics – Paper I", href: "/files/2025-maths-1.pdf", type: "Advanced Exam" },
    { title: "Mathematics – Paper II", href: "/files/2025-maths-2.pdf", type: "Advanced Exam" },
    { title: "Physics – Structured", href: "/files/2025-physics-structured.pdf", type: "Intermediate Upper Exam" },
  ],
  2024: [
    { title: "Biology – MCQ", href: "/files/2024-bio-mcq.pdf", type: "Mid Intermediate Exam" },
    { title: "Biology – Essay", href: "/files/2024-bio-essay.pdf", type: "Intermediate Upper Exam" },
    { title: "Physics – Structured", href: "/files/2024-physics-structured.pdf", type: "Intermediate Upper Exam" },
  ],
  2023: [
    { title: "Chemistry – Paper I", href: "/files/2023-chem-1.pdf", type: "Intermediate Upper Exam" },
    { title: "Chemistry – Paper II", href: "/files/2023-chem-2.pdf", type: "Advanced Exam" },
    { title: "Physics – Paper I", href: "/files/2023-physics-1.pdf", type: "Intermediate Lower Exam" },
  ],
  2022: [
    { title: "Mathematics – Paper I", href: "/files/2022-maths-1.pdf", type: "Intermediate Lower Exam" },
    { title: "Mathematics – Paper II", href: "/files/2022-maths-2.pdf", type: "Mid Intermediate Exam" },
    { title: "Biology – MCQ", href: "/files/2022-bio-mcq.pdf", type: "Basic Exam" },
  ],
  2021: [
    { title: "Physics – MCQ", href: "/files/2021-physics-mcq.pdf", type: "Basic Exam" },
    { title: "Chemistry – Paper I", href: "/files/2021-chem-1.pdf", type: "Intermediate Lower Exam" },
    { title: "Mathematics – Paper I", href: "/files/2021-maths-1.pdf", type: "Mid Intermediate Exam" },
  ],
  2020: [
    { title: "Physics – Essay", href: "/files/2020-physics-essay.pdf", type: "Advanced Exam" },
    { title: "Biology – MCQ", href: "/files/2020-bio-mcq.pdf", type: "Basic Exam" },
    { title: "Chemistry – Structured", href: "/files/2020-chem-structured.pdf", type: "Intermediate Upper Exam" },
  ],
  2019: [
    { title: "Mathematics – Paper I", href: "/files/2019-maths-1.pdf", type: "Intermediate Lower Exam" },
    { title: "Physics – Paper II", href: "/files/2019-physics-2.pdf", type: "Advanced Exam" },
    { title: "Chemistry – MCQ", href: "/files/2019-chem-mcq.pdf", type: "Basic Exam" },
  ],
  2018: [
    { title: "Biology – Essay", href: "/files/2018-bio-essay.pdf", type: "Advanced Exam" },
    { title: "Physics – Paper I", href: "/files/2018-physics-1.pdf", type: "Intermediate Lower Exam" },
    { title: "Mathematics – Paper II", href: "/files/2018-maths-2.pdf", type: "Mid Intermediate Exam" },
  ],
  2017: [
    { title: "Physics – Structured", href: "/files/2017-physics-structured.pdf", type: "Intermediate Upper Exam" },
    { title: "Chemistry – Paper I", href: "/files/2017-chem-1.pdf", type: "Intermediate Lower Exam" },
    { title: "Biology – MCQ", href: "/files/2017-bio-mcq.pdf", type: "Basic Exam" },
  ],
  2016: [
    { title: "Mathematics – Paper I", href: "/files/2016-maths-1.pdf", type: "Intermediate Lower Exam" },
    { title: "Physics – Paper II", href: "/files/2016-physics-2.pdf", type: "Advanced Exam" },
    { title: "Chemistry – Essay", href: "/files/2016-chem-essay.pdf", type: "Advanced Exam" },
  ],
  2015: [
    { title: "Biology – Structured", href: "/files/2015-bio-structured.pdf", type: "Intermediate Upper Exam" },
    { title: "Physics – MCQ", href: "/files/2015-physics-mcq.pdf", type: "Basic Exam" },
    { title: "Mathematics – Paper II", href: "/files/2015-maths-2.pdf", type: "Mid Intermediate Exam" },
  ],
  2014: [
    { title: "Physics – Paper I", href: "/files/2014-physics-1.pdf", type: "Intermediate Lower Exam" },
    { title: "Biology – Paper II", href: "/files/2014-bio-2.pdf", type: "Advanced Exam" },
    { title: "Chemistry – MCQ", href: "/files/2014-chem-mcq.pdf", type: "Basic Exam" },
  ],
  2013: [
    { title: "Mathematics – Paper I", href: "/files/2013-maths-1.pdf", type: "Intermediate Lower Exam" },
    { title: "Physics – Structured", href: "/files/2013-physics-structured.pdf", type: "Intermediate Upper Exam" },
    { title: "Chemistry – Essay", href: "/files/2013-chem-essay.pdf", type: "Advanced Exam" },
  ],
  2012: [
    { title: "Biology – Paper I", href: "/files/2012-bio-1.pdf", type: "Intermediate Lower Exam" },
    { title: "Physics – Paper II", href: "/files/2012-physics-2.pdf", type: "Advanced Exam" },
    { title: "Mathematics – Paper I", href: "/files/2012-maths-1.pdf", type: "Mid Intermediate Exam" },
  ],
  2011: [
    { title: "Physics – MCQ", href: "/files/2011-physics-mcq.pdf", type: "Basic Exam" },
    { title: "Chemistry – Paper II", href: "/files/2011-chem-2.pdf", type: "Advanced Exam" },
    { title: "Mathematics – Paper I", href: "/files/2011-maths-1.pdf", type: "Intermediate Lower Exam" },
  ],
  2010: [
    { title: "Biology – Structured", href: "/files/2010-bio-structured.pdf", type: "Intermediate Upper Exam" },
    { title: "Physics – Paper I", href: "/files/2010-physics-1.pdf", type: "Intermediate Lower Exam" },
    { title: "Chemistry – Essay", href: "/files/2010-chem-essay.pdf", type: "Advanced Exam" },
  ],
  2009: [
    { title: "Mathematics – Paper I", href: "/files/2009-maths-1.pdf", type: "Intermediate Lower Exam" },
    { title: "Physics – Paper II", href: "/files/2009-physics-2.pdf", type: "Advanced Exam" },
    { title: "Biology – MCQ", href: "/files/2009-bio-mcq.pdf", type: "Basic Exam" },
  ],
  2008: [
    { title: "Physics – Paper I", href: "/files/2008-physics-1.pdf", type: "Intermediate Lower Exam" },
    { title: "Chemistry – Paper II", href: "/files/2008-chem-2.pdf", type: "Advanced Exam" },
    { title: "Biology – Essay", href: "/files/2008-bio-essay.pdf", type: "Advanced Exam" },
  ],
  2007: [
    { title: "Mathematics – Paper I", href: "/files/2007-maths-1.pdf", type: "Intermediate Lower Exam" },
    { title: "Physics – Structured", href: "/files/2007-physics-structured.pdf", type: "Intermediate Upper Exam" },
    { title: "Chemistry – MCQ", href: "/files/2007-chem-mcq.pdf", type: "Basic Exam" },
  ],
  2006: [
    { title: "Biology – Paper I", href: "/files/2006-bio-1.pdf", type: "Intermediate Lower Exam" },
    { title: "Physics – Paper II", href: "/files/2006-physics-2.pdf", type: "Advanced Exam" },
    { title: "Mathematics – Paper II", href: "/files/2006-maths-2.pdf", type: "Mid Intermediate Exam" },
  ],
  2005: [
    { title: "Physics – MCQ", href: "/files/2005-physics-mcq.pdf", type: "Basic Exam" },
    { title: "Chemistry – Paper I", href: "/files/2005-chem-1.pdf", type: "Intermediate Lower Exam" },
    { title: "Mathematics – Paper I", href: "/files/2005-maths-1.pdf", type: "Intermediate Lower Exam" },
  ],
  2004: [
    { title: "Biology – Essay", href: "/files/2004-bio-essay.pdf", type: "Advanced Exam" },
    { title: "Physics – Paper I", href: "/files/2004-physics-1.pdf", type: "Intermediate Lower Exam" },
    { title: "Chemistry – Structured", href: "/files/2004-chem-structured.pdf", type: "Intermediate Upper Exam" },
  ],
  2003: [
    { title: "Mathematics – Paper I", href: "/files/2003-maths-1.pdf", type: "Intermediate Lower Exam" },
    { title: "Physics – MCQ", href: "/files/2003-physics-mcq.pdf", type: "Basic Exam" },
    { title: "Biology – Structured", href: "/files/2003-bio-structured.pdf", type: "Intermediate Upper Exam" },
  ],
};

export const tamilAnthem = [
  "வாழ்க தமிழ்மொழி!\nவாழ்க தமிழ்மொழி!\nவாழ்க தமிழ்மொழி யே!",
  "வாழ்க  நிரந்தரம்  வாழ்க  தமிழ்மொழி\nவாழிய வாழியவே!\nவான மளந்த தனைத்தும்  அளந்திடும்\nவண்மொழி வாழியவே!",
  "ஏழ்கடல் வைப்பினுந் தன்மணம் வீசி\nஇசைகொண்டு வாழியவே!\nஎங்கள் தமிழ்மொழி! எங்கள் தமிழ்மொழி!\nஎன்றென்றும் வாழிய வே!",
  "சூழ்கலி நீங்கத் தமிழ்மொழி\nஓங்கத்துலங்குக வையக மே!\nவாழ்க தமிழ்மொழி! வாழ்க தமிழ்மொழி!\nவாழ்க தமிழ்மொழி யே!",
  "வானம் அறிந்த தனைத்தும்\nஅறிந்து வளர்மொழி வாழிய வே!\nவாழ்க தமிழ்மொழி! வாழ்க தமிழ்மொழி!\nவாழ்க தமிழ்மொழி யே!",
  "வாழ்க  நிரந்தரம்  வாழ்க  தமிழ்மொழி\nவாழிய வாழிய வே!\nவாழ்க தமிழ்மொழி! வாழ்க தமிழ்மொழி!\nவாழ்க தமிழ்மொழி யே!",
  "எங்கள் தமிழ்மொழி! ...\nஎங்கள் தமிழ்மொழி! ...\nஎன்றென்றும் வாழிய வே!",
];

export const aboutData = [
  {
    title: "Our Mission",
    content: [
      "Deliver high-quality Tamil language education from Preschool to Year 12",
      "Foster pride in Tamil heritage and cultural identity",
      "Support student confidence, wellbeing, and lifelong learning",
      "Strengthen community connection across generations"
    ]
  },
  {
    title: "Our Values",
    content: [
      "Cultural Pride: Honouring Tamil language, history, and traditions",
      "Inclusivity: Welcoming students of all backgrounds and abilities",
      "Excellence: High standards in teaching and learning",
      "Community: Strong partnerships with families and the Tamil community",
      "Integrity: Transparent governance and ethical management"
    ]
  }
];

export const programStages = [
  {
    stage: "Early Stage 1",
    years: "Preschool / Kindergarten",
    focus: "Tamil foundations, basic oral skills, vowel recognition",
  },
  {
    stage: "Stage 1",
    years: "Years 1 – 2",
    focus:
      "Listening and speaking through songs, stories, and vocabulary from daily life.",
  },
  {
    stage: "Stage 2",
    years: "Years 3 – 4",
    focus:
      "Early reading and writing, introduction to Tamil script and basic grammar.",
  },
  {
    stage: "Stage 3",
    years: "Years 5 – 6",
    focus:
      "Paragraph writing, comprehension, and cultural themes (festivals, traditions).",
  },
  {
    stage: "Stage 4",
    years: "Years 7 – 8",
    focus:
      "Grammar expansion, translation, and conversational Tamil.",
  },
  {
    stage: "Stage 5",
    years: "Years 9 – 10",
    focus:
      "Extended writing, cultural analysis, and introduction to Tamil literature.",
  },
  {
    stage: "Stage 6",
    years: "Years 11 – 12",
    focus:
      "Preparation for Continuers/Extension courses; study of texts and cultural identity.",
  },
];

// Shared by the Home page tabs and the About page.
export const aboutTopics = [
  {
    id: "approach",
    title: "Teaching & Learning Approach",
    description:
      "Our teaching approach is student-centred, interactive, and culturally responsive. Lessons are designed to be engaging and age-appropriate, using a mix of traditional and modern teaching methods.",
    focusTitle: "We focus on:",
    points: [
      "Active participation and communication",
      "Positive reinforcement and confidence building",
      "Collaboration between teachers, parents, and students",
    ],
  },
  {
    id: "teachers",
    title: "Our Teaching Staff",
    description:
      "Our teachers are experienced Tamil language educators who are passionate about community language education.",
    focusTitle: "All teachers:",
    points: [
      "Have relevant teaching experience",
      "Participate in ongoing professional development",
      "Follow child safety and ethical teaching standards",
    ],
  },
  {
    id: "governance",
    title: "Governance & Accountability",
    description:
      "Western Sydney Tamil Study Centre is governed by a community-based Management Committee responsible for strategic planning, compliance, and financial oversight.",
    focusTitle: "We are committed to:",
    points: [
      "Transparent and accountable decision-making",
      "Responsible financial management",
      "Managing conflicts of interest appropriately",
      "Clear processes for feedback, concerns, and complaints",
    ],
    bottomText:
      "Parents and members are encouraged to raise concerns through our formal complaints and feedback process.",
  },
  {
    id: "community",
    title: "Community Engagement",
    description:
      "We actively engage with the Western Sydney Tamil community through a range of cultural, educational, and leadership-focused initiatives.",
    focusTitle: "We support:",
    // points: [
    //   "Cultural celebrations and festivals",
    //   "Parent information sessions",
    //   "Student performances and community events",
    //   "Volunteer and leadership opportunities",
    // ],
  },
  {
    id: "child-safety",
    title: "Child Safety",
    description:
      "Western Sydney Tamil Study Centre is committed to providing a safe, inclusive, and supportive environment for all students.",
    focusTitle: "We ensure:",
    points: [
      "Recognised child safe standards",
      "Clear policies and procedures to protect students",
      "Student wellbeing, dignity, and safety at all times",
    ],
  },
];
